export const ROUTES = {
  HOME: '/',
  CATALOG: '/catalogo',
  CATEGORY: '/categoria/:slug',
  SUBCATEGORY: '/categoria/:slug/:subslug',
  PRODUCT: '/producto/:slug',
  SEARCH: '/buscar',
  BRANDS: '/marcas',
  BRAND: '/marca/:slug',
  PROMOTIONS: '/promociones',
  NEWS: '/novedades',
  CART: '/carrito',
  CHECKOUT: '/checkout',
  ORDER_CONFIRMATION: '/pedido/confirmacion/:orderId',
  ORDER_TRACKING: '/pedido/seguimiento/:orderId',
  LOGIN: '/ingresar',
  REGISTER: '/registro',
  FORGOT_PASSWORD: '/recuperar-contrasena',
  ACTIVATE_ACCOUNT: '/activar-cuenta',
  B2B_ACCESS_REQUEST: '/solicitar-acceso-mayorista',
  ACCOUNT: '/cuenta',
  PROFILE: '/cuenta/datos',
  ADDRESSES: '/cuenta/direcciones',
  ORDERS: '/cuenta/pedidos',
  ORDERS_IN_PREPARATION: '/cuenta/pedidos-en-preparacion',
  CURRENT_ACCOUNT: '/cuenta/cuenta-corriente',
  PAYMENT_NOTICES: '/cuenta/informar-pagos',
  FAVORITES: '/cuenta/favoritos',
  HISTORY: '/cuenta/historial',
  QUICK_ORDER: '/cuenta/pedido-rapido',
  ADMIN: '/admin',
  ADMIN_LOGIN: '/admin/ingresar',
  ADMIN_AUTH_CALLBACK: '/admin/auth/callback',
  ADMIN_APPEARANCE: '/admin/apariencia',
  ADMIN_LAYOUT: '/admin/layout',
  ADMIN_NAVIGATION: '/admin/navegacion',
  ADMIN_AUTH_PAGE: '/admin/pagina-ingreso',
  ADMIN_CATALOG: '/admin/catalogo',
  ADMIN_FEATURES: '/admin/funcionalidades',
  ADMIN_CONFIG_PACK: '/admin/migracion',
  STORE_UNAVAILABLE: '/tienda-no-disponible',
} as const;

export const getSafeRedirectPath = (value: string | null | undefined): string => {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.startsWith('/admin')) {
    return ROUTES.HOME;
  }
  return value;
};
